// Layout.tsx
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CookieConsent from '../../components/CookieConsent/CookieConsent';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import styles from './Layout.module.scss';

const Layout = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();
    const noHeaderRoutes = ['/servicos'];
    const showHeader = !noHeaderRoutes.includes(location.pathname);

    return (
        <div className={styles.layout_container}>
            {showHeader && <Header />}
            <motion.main
                className={styles.main_container}
                key={location.pathname}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
            >
                {children}
            </motion.main>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                transition={Bounce}
                toastClassName={styles.custom_toast}
            />
            <Footer />
            <CookieConsent />
        </div>
    );
};

export default Layout;
